const userToReader = query => {
  return {
    'includes[leitor][user_id]':
      query.user_id === undefined ? undefined : query.user_id
  }
}

export default userToReader
